import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Location } from '@angular/common';
import { map, tap } from 'rxjs/operators';

import * as RouterActions from '../actions/router.actions';

@Injectable()
export class RouterEffects {
    private actions$ = inject(Actions);
    private router = inject(Router);
    private location = inject(Location);

    navigate$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(RouterActions.GO),
                map((action: RouterActions.Go) => action.payload),
                tap(({ path, query: queryParams, extras }) => this.router.navigate(path, { queryParams, ...extras }))
            ),
        { dispatch: false }
    );
}
